import { ECommerce } from "ui/forms/Onboarding";
import { Step, withStepData } from "ui/organizms/Onboarding/Applications/common";
import useBankingAndFinance from "./useBankingAndFinance";

const BankingAndFinance = () => {
    const bankingAndFinance = useBankingAndFinance();

    return (
        <Step
            title='Banking & Finance'
        >
            <ECommerce.BankingAndFinance.Form
                {...bankingAndFinance}
            />
        </Step>
    );
};

export default withStepData(BankingAndFinance);
